// packages import
import { Box, List, ListItem, Typography } from "@mui/material";
import { FC, useContext } from "react";
import { AppContext } from "../../../context";
// component import
import { CardBox } from "../../../theme/styleComponents";
import { infoText } from "../../../theme/styleConstants";
import { CalendarEvents } from "./MyCalendar";

export const Events: FC = () => {
  const { outlookUser } = useContext(AppContext);

  return (
    <Box width='100%' pr='1px'>
      <Typography fontSize='24px' fontWeight={400}>
        Calendar Events
      </Typography>

      <CardBox p='24px' mt='16px' minHeight='425px' mb={3}>
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Typography fontSize='20px' fontWeight={500}>Upcoming events</Typography>

          {outlookUser &&
            <List>
              <ListItem sx={{ fontSize: '8px', paddingBlock: 0 }}>
                <Box sx={{ backgroundColor: '#187711', ...infoText }} />Other events
              </ListItem>
              <ListItem sx={{ fontSize: '8px', paddingBlock: 0 }}>
                <Box sx={{ backgroundColor: 'darkRed', ...infoText }} />Events
              </ListItem>
              <ListItem sx={{ fontSize: '8px', paddingBlock: 0 }}>
                <Box sx={{ backgroundColor: '#ffc8ce', ...infoText }} />Court date
              </ListItem>
            </List>
          }
        </Box>

        <CalendarEvents />
      </CardBox>
    </Box>
  )
}